import { SLOTS } from './slots.js'

const AD_TYPE_BADGES = {
  reward: { label: 'Reward', badgeClass: 'badge-success' },
  event: { label: 'Event', badgeClass: 'badge-info' },
  event_with_reward: { label: 'Event + Reward', badgeClass: 'badge-accent' }
}

// Campaigns: ranked, drag-reorderable feed ads scoped to a place. Primary links to edit.
export default {
  key: 'campaign',
  label: 'Campaign',
  icon: 'campaigns',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.CONTEXT, field: 'place.label', label: 'Place', link: 'place.url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    { slot: SLOTS.METADATA, field: 'rank', label: 'Rank', renderer: 'points', align: 'right' },
    { slot: SLOTS.METADATA, field: 'ad_type', label: 'Type', renderer: 'state_badge', badges: AD_TYPE_BADGES },
    { slot: SLOTS.METADATA, field: 'feeds_label', label: 'Feeds' },
    { slot: SLOTS.METADATA, field: 'audience_label', label: 'Audience' },
    { slot: SLOTS.METADATA, field: 'schedule', label: 'Schedule', renderer: 'schedule' }
  ],
  empty: { icon: 'campaigns', message: 'No campaigns found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
